import { api } from "../../axios";

export const actions = {
    //Warehouse
    GetWarehouseBuilding(context, data){
        return api.get(`Warehouse/Building/${data}`);
    },
    GetWarehouseLocation(context, data){
        return api.get(`Warehouse/Location/${data}`);
    },

    //Location Area
    GetSingleLocationArea(context, data){
        return api.get(`LocationArea/${data}`);
    },
    GetLocationAreaByLocation(context, data){
        return api.get(`LocationArea/PropertyLocation/${data}`);
    },
    GetLocationAreaByParent(context, data){
        return api.get(`LocationArea/Parent/${data}`);
    },
    UpdateLocationArea(context, data){
        return api.put(`LocationArea/${data.id}`, data);
    },
    DeleteLocationArea(context, data){
        return api.delete(`LocationArea/${data}`);
    },
    CreateLocationArea(context, data){
        return api.post(`LocationArea/Add`, data);
    },

}